export default __webpack_public_path__ + "static/media/tbox.3544f54a.jpg";